module.exports = __webpack_public_path__ + "static/img/15areaB_5.d77ca17.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/15areaB_5.png
// module id = 1127
// module chunks = 1